<template>
  <div class="container pt-5">
    <div class="row">
      <div class="col-lg-3 col-md-6 col-sm-6 col-6" v-for="(cat, index) in this.categories" :key="index">
        <RouterLink :to="'/category/'+ cat.slug">
        <div class="card mt-2">
          <div class="card-body p-0 position-relative">
            <img
                class="card-img"
                :src="cat.imageUrl ? cat.imageUrl : '/images/categoria.jpg'"
                alt="Category image">
            <div class="overlay"></div>
            <div class="card-img-overlay d-flex flex-column justify-content-center align-items-center">
              <div class="top-left-text">{{ cat.description }}</div>
            </div>
          </div>
        </div>
        </RouterLink>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "ShowBoxCategories",
  data() {
    return {
      categories: null
    }
  },
  mounted() {
    this.$store.dispatch("getCategories").then(() => {
      const categories = this.$store.getters.getCategories;
      if (categories) {
        // Limita le categorie a 4
        this.categories = categories.slice(0, 4);
      }
    });
  }

}

</script>

<style scoped>
.card {
  font-size: 20px;
  font-weight: bold;
  width: 100%;
  max-width: 300px;
  height: 250px;
  overflow: hidden;
  transition: transform 0.3s;
  border: none;
}

.card-img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  transition: transform 0.3s ease;
}

.card-body {
  position: relative;
  width: 100%;
  height: 100%;
}


.card:hover {
  z-index: 2;
  transform: scale(1.05);
}

.card-img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  transition: transform 0.3s ease;
}

.card:hover .card-img {
  transform: scale(1.1);
}

.overlay {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.4);
  opacity: 0;
  transition: opacity 0.3s ease;
}

.card:hover .overlay {
  opacity: 1;
}

.card-img-overlay {
  color: white;
  z-index: 1;
  text-align: center;
  font-weight: bold;
  opacity: 1;
  transition: opacity 0.3s ease;
}

.top-left-text {
  padding: 10px;
}

</style>